import { Subject } from 'rxjs';

const searchTwitterSubject = new Subject();

export const updateSearchTwitterSubject = {
  update: message => searchTwitterSubject.next(message),
  clear: () => searchTwitterSubject.next(),
  get: () => searchTwitterSubject.asObservable()
};
